import * as actionTypes from '../actionTypes/SameDayPickupActionTypes';

const initBOPISSectionUI = (orderDetailsInfo, storeInfo, isLoadedFromReview, isUserLoggedIn) => ({
    type: actionTypes.INIT_BOPIS_SECTION_UI,
    orderDetailsInfo,
    storeInfo,
    isLoadedFromReview,
    isUserLoggedIn,
});

const showAlternatePickupPersonForm = (showAlternatePickPerson = false) => ({
    type: actionTypes.SHOW_ALTERNATE_PICKUP_PERSON_FORM,
    showAlternatePickPerson,
});

const alternatePickupFormFieldError = (attribute) => ({
    type: actionTypes.ALTERNATE_PICKUP_FORM_FIELD_ERROR,
    attribute,
});

const alternatePickupFormChangeValue = (attribute, newValue) => ({
    type: actionTypes.ALTERNATE_PICKUP_FORM_CHANGE_VALUE,
    attribute,
    newValue,
});

const handleSubmitBopisSection = () => ({
    type: actionTypes.SUBMIT_BOPIS_SECTION,
});

const alternatePickupFormError = (pickUpFormError) => ({
    type: actionTypes.ALTERNATE_PICKUP_FORM_ERROR,
    pickUpFormError,
});

export {
    initBOPISSectionUI,
    showAlternatePickupPersonForm,
    alternatePickupFormFieldError,
    alternatePickupFormChangeValue,
    handleSubmitBopisSection,
    alternatePickupFormError,
};
